"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.ProductLogAPI = {
    getProductLogs: function (companyId, filters) { return index_1.axios.get("/api/v1/company/" + companyId + "/productLog", {
        params: __assign({}, filters),
    }).then(function (response) {
        var productLogs = response.data;
        return productLogs;
    }); },
};
//# sourceMappingURL=ProductLogAPI.js.map